import React from "react";
import Typography from "@material-ui/core/Typography";
import tableicons from "../tableicons";
import MaterialTable from "material-table";
import {productividadResources} from "../endpoints";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import SvgIcon from "@material-ui/core/SvgIcon";
import DialogExportar from "../components/DialogExportar";
import SnackbarAlert from "../components/SnackbarAlert";
import useToken from "../useToken";
import { Redirect } from "react-router-dom";

class Rendimiento extends React.Component{
    constructor(props) {
        super(props);
        this.state={
            disponibles: [],
            open:false,
            message: '',
            severity: '',
            openSnack: false,
        }
    }

    getRendimiento(){
        productividadResources.getRendimiento().then(async response => {
            if (response) {
                return await response.json();
            }
        }).then(result => {
            if(result.status_code === 200){
                this.setState({disponibles:result.rendimiento})
            }
            else{
                throw new Error('Something went wrong ...');
            }
        }).catch(error=> {
            console.log(error)
        });
    }

    handleClose = () => {
        this.setState({open: false})
    }

    refrescar =(estado,severity) =>{
        this.setState({ open: false, openSnack: false})
        if (severity){
            this.setState({
                open: false,
                openSnack: true,
                message: estado,
                severity: severity
            })
        }
    }

    enviarDatosReportes =(nombre)=>{
        let params = ""
        let reporte = nombre
        let origen  = "otro"

        this.setState({open: true, reporte: reporte, params: params,openSnack:false, origen:origen})
    }

    componentDidMount() {
        const verifyFolio = useToken.verifyToken()
        if(!verifyFolio){
            this.props.history.push('/inventarios');
        }
        else{
            this.getRendimiento()
        }
    }

    render() {
        const verifyFolio = useToken.verifyToken()

        if(!verifyFolio){
            return <Redirect to="/inventarios"/>
        }
        else{
            return (
                <div>
                    <Typography variant="h4" gutterBottom>
                        Rendimiento Operadores
                    </Typography>
                    <Grid container direction="row" justifyContent="flex-end" alignItems="center" spacing={2} style={{padding:10, marginBottom:10}}>
                        <Grid item>
                            <Button startIcon={ <SvgIcon>
                                <path fill="currentColor" d="M6,2C4.89,2 4,2.9 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M13,3.5L18.5,9H13M8.93,12.22H16V19.29L13.88,17.17L11.05,20L8.22,17.17L11.05,14.35" />
                            </SvgIcon>} variant="contained" name="rendimiento_operador" color="primary" onClick={() => this.enviarDatosReportes("rendimiento_operador")}>
                                Rendimiento</Button>
                        </Grid>
                    </Grid>

                    <MaterialTable
                        title=" "
                        icons={tableicons}
                        columns={[
                            { title: 'Cod.Usuario', field: 'usuario',
                                cellStyle: {
                                    width: 400,
                                    maxWidth: 400,
                                },
                                headerStyle: {
                                    width: 400,
                                    maxWidth: 400
                                }
                            },
                            {title: 'Registros', field: 'registros' },
                            { title: 'Unidades', field: 'unidades_contadas' },
                            {title: 'Horas Escaneo', field: 'tiempo_escaneo',
                                render: rowData => (rowData.tiempo_escaneo).toFixed(2),
                            },
                            {title: 'Reg. x Hr', field: 'rg_hora',
                                render: rowData => (rowData.rg_hora).toFixed(2),
                            },
                            {title: 'Un. x Hr', field: 'un_hora',
                                render: rowData => (rowData.un_hora).toFixed(2),
                            },
                            {title: 'Error (%)', field: 'error',
                                render: rowData => ((rowData.error  * 100)).toFixed(2) + ' %',
                            },
                            {title: 'Modificaciones (%)', field: 'modificaciones',
                                render: rowData => ((rowData.modificaciones  * 100)).toFixed(2) + ' %',
                            },

                        ]}
                        data={this.state.disponibles}
                        options={{
                            pageSize: 25,
                            pageSizeOptions: [10, 25, 50, 100],
                            actionsColumnIndex: -1,
                            rowStyle: rowData => ({
                                backgroundColor: (this.state.selectedRow === rowData.tableData.id) ? '#dbe9fc' :  (rowData.avance === 1 && rowData.descripcion !=='SIN UBICACION') ? '#6fbf73' : (rowData.cant_inv === 0) ? '#FD8080' :  (rowData.descripcion === 'SIN UBICACION') ? '#EC7063':'#FFF'
                            }),
                            searchFieldStyle: {
                                width: "auto",
                            },
                            padding: "dense"
                        }}
                        localization={{
                            toolbar: {
                                searchPlaceholder: 'Buscar'
                            },
                            header: {
                                actions: 'Acciones'
                            },
                            body:{
                                emptyDataSourceMessage: 'No hay datos para mostrar'
                            }
                        }}
                        onRowClick={(event, rowData) => this.setState({selectedRow: rowData.tableData.id})}
                    />
                    {this.state.openSnack? <SnackbarAlert severity={this.state.severity} message={this.state.message}/> : null}
                    {this.state.open? <DialogExportar reporte={this.state.reporte} origen={this.state.origen} params={this.state.params} refrescar={this.refrescar} handleClose={this.handleClose}/> : null}

                </div>
            )
        }
    }
}

export default Rendimiento;